/** Strip marketplace prefixes (e.g. "Amazon.com: ") from product titles for cleaner display */
export function cleanProductTitle(title: string | undefined | null): string {
  if (!title) return '';
  return title.replace(/^Amazon\.com:\s*/i, '');
}

/** Patterns in title/snippet that indicate a non-skincare product */
const IRRELEVANT_TITLE_RE =
  /\b(blu-ray|dvd|paperback|hardcover|kindle|audiobook|board game|video game|console|movie|film|novel|fiction|romance|thriller|mystery|cookbook|textbook|calendar|poster|vinyl|lp|cd album|action figure|toy|puzzle|playing cards|headphone|speaker|charger|cable|adapter|laptop|tablet|phone case|screen protector|case study|고객사례|성공 사례|광고 매출|성장을 달성|AWS|LTL|FTL|FCL|배송에 대한|Twitch|슈퍼스타)\b/i;

/** URL path segments for non-beauty departments (primarily Amazon, but may appear in other stores) */
const IRRELEVANT_URL_RE =
  /\/(books|music|movies-tv|video-games|electronics|toys-games|office-products|automotive|musical-instruments|grocery|pet-supplies|sports|tools|garden|industrial|software|audible|kindle-dbs)\//i;

/** URL domains/paths that are NOT product pages (advertising portals, case studies, corporate blogs) */
const NON_PRODUCT_URL_RE =
  /\b(advertising\.amazon|ads\.amazon|aws\.amazon|sellercentral|affiliate-program|developer\.amazon|aboutamazon|press\.aboutamazon|blog\.aboutamazon)\b/i;

/**
 * Returns true if a search result looks like an actual skincare / beauty /
 * personal-care product. Filters out ads for books, movies, electronics,
 * etc. that leak through Google Custom Search.
 *
 * Applied to all search results (Amazon and non-Amazon alike).
 */
export function isRelevantBeautyProduct(title: string, url: string, snippet: string): boolean {
  // Empty/missing metadata → assume relevant (don't accidentally drop valid items)
  if (!title && !url && !snippet) return true;
  if (IRRELEVANT_TITLE_RE.test(title) || IRRELEVANT_TITLE_RE.test(snippet)) return false;
  if (IRRELEVANT_URL_RE.test(url)) return false;
  if (NON_PRODUCT_URL_RE.test(url)) return false;
  return true;
}
